import { generateUuid } from '@lib/uuid';

export const uuid = (length: number): string => {
  return generateUuid().slice(-length);
};
